import React from 'react';
import { InstagramIcon } from 'lucide-react';
import { Logo } from './Logo';
import { GOOGLE_REVIEWS_URL } from '../data/reviews';
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from '../data/site';
import { SECTION_IDS, SectionId, scrollToSection } from '../utils/scroll';
const links: {
  label: string;
  id: SectionId;
}[] = [{
  label: 'Cómo funciona',
  id: SECTION_IDS.proceso
}, {
  label: 'Servicios',
  id: SECTION_IDS.servicios
}, {
  label: 'Testimonios',
  id: SECTION_IDS.testimonios
}, {
  label: 'Preguntas',
  id: SECTION_IDS.preguntas
}];
export function Footer() {
  return <footer className="bg-plum-900 text-ivory" data-id="element-40" data-mp="3lec9wggp4cgx">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-14" data-id="element-41" data-mp="3ldkdx4j6scq4">
        <div className="flex flex-col gap-9 sm:flex-row sm:items-start sm:justify-between sm:gap-16" data-id="element-42" data-mp="3qcnlavmn2v19">
          <div data-id="element-43" data-mp="29yxbr9cr3ek8">
            <Logo tone="light" data-id="element-44" data-mp="29ydwk0ehj49w" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-lavender-200/90" data-id="element-45" data-mp="2a19qzer4jatl">
              Consultoría y creación de negocios en Florida: estructura, identidad y
              presencia digital.
            </p>

            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-analytics-id="instagram_footer" className="mt-5 inline-flex items-center gap-2 text-sm text-lavender-200/90 transition-colors duration-200 ease-premium hover:text-ivory" data-id="element-46" data-mp="3gapbneqg0cdv">
              <InstagramIcon className="h-4 w-4" strokeWidth={1.6} aria-hidden="true" data-id="element-47" data-mp="81pgvn5hf5bh" />
              {INSTAGRAM_HANDLE}
            </a>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 sm:gap-16" data-id="element-48" data-mp="hsttig7oqe35">
            <nav aria-label="Secciones" className="grid gap-3" data-id="element-49" data-mp="hs1yb6i02ide">
              <p className="eyebrow text-lavender-300" data-id="element-50" data-mp="ctgxp5yu5wof">Explorar</p>
              {links.map(link => <button key={link.id} type="button" onClick={() => scrollToSection(link.id)} className="text-left text-sm text-lavender-200/90 transition-colors duration-200 ease-premium hover:text-ivory" data-id="element-51" data-mp="qujm3pdazj2i">
                  {link.label}
                </button>)}
            </nav>

            <div className="grid gap-3" data-id="element-52" data-mp="13sr7121hjjvb">
              <p className="eyebrow text-lavender-300" data-id="element-53" data-mp="13rzigb6b2mej">Confianza</p>
              <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-analytics-id="google-reviews-footer" className="text-sm text-lavender-200/90 transition-colors duration-200 ease-premium hover:text-ivory" data-id="element-54" data-mp="18l2f4s6dqbyy">
                Reseñas en Google
              </a>
              <p className="text-sm text-lavender-200/70" data-id="element-55" data-mp="1rilipga2j2dz">Negocios en Florida</p>
            </div>
          </div>
        </div>

        <div className="mt-10 h-px w-full bg-lavender-300/25" data-id="element-56" data-mp="3oc6rez4cz201" />

        <p className="mt-6 text-xs text-lavender-200/70" data-id="element-57" data-mp="3t9yi5pt9oi2n">
          © {new Date().getFullYear()} Inkova Business Consulting &amp; Creation.
        </p>
      </div>
    </footer>;
}